import { render, staticRenderFns } from "./switch-field.vue?vue&type=template&id=d6d0f986"
import script from "./switch-field.vue?vue&type=script&lang=js"
export * from "./switch-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports